module.exports = __webpack_public_path__ + "img/kkb_harting.7a930459.jpg";